import * as actions from './actions';
import { LoadingAction } from '../common/loading-action';
import { ErrorAction } from '../common/error-action';
import { Subdomain } from '@services/subdomains/types/subdomain';

export class GetSubdomain implements LoadingAction {
  readonly type = actions.GET_SUBDOMAIN;
  readonly isLoading = true;

  constructor (public ownerId: string) {}
}

export class GetSubdomainSuccess implements LoadingAction {
  readonly type = actions.GET_SUBDOMAIN_SUCCESS;
  readonly isLoading = false;

  constructor (
    public subdomain: Subdomain,
  ) {}
}

export class GetSubdomainError implements ErrorAction {
  readonly type = actions.GET_SUBDOMAIN_ERROR;
  readonly isError = true;

  constructor (public code: string) {}
}

export class UpdateSubdomain implements LoadingAction {
  readonly type = actions.UPDATE_SUBDOMAIN;
  readonly isLoading = true;

  constructor (public subdomainName: string) {}
}

export class UpdateSubdomainSuccess implements LoadingAction {
  readonly type = actions.UPDATE_SUBDOMAIN_SUCCESS;
  readonly isLoading = false;

  constructor (public subdomain: Subdomain) {}
}

export class UpdateSubdomainError implements ErrorAction {
  readonly type = actions.UPDATE_SUBDOMAIN_ERROR;
  readonly isError = true;

  constructor (public code: string) {}
}

export class QuerySubdomain implements LoadingAction {
  readonly type = actions.QUERY_SUBDOMAIN;
  readonly isLoading = true;

  constructor(public name: string) {}
}

export class QuerySubdomainSuccess implements LoadingAction {
  readonly type = actions.QUERY_SUBDOMAIN_SUCCESS;
  readonly isLoading = false;

  constructor (public subdomain: Subdomain) {}
}

export class QuerySubdomainError implements ErrorAction {
  readonly type = actions.QUERY_SUBDOMAIN_ERROR;
  readonly isError = true;

  constructor(public code: string) {}
}

export type SubdomainActions = 
  | QuerySubdomain
  | QuerySubdomainSuccess
  | QuerySubdomainError
  | GetSubdomain
  | GetSubdomainSuccess
  | GetSubdomainError
  | UpdateSubdomain
  | UpdateSubdomainSuccess
  | UpdateSubdomainError
;